// The appearance a person chose — light, dark, or whatever their device uses
// — and the mode that choice makes the app. Pure, so it is tested without a
// browser (colorMode.test.js); AppThemeProvider keeps the choice.

export const COLOR_PREFERENCES = ['light', 'dark', 'system'];
export const COLOR_PREFERENCE_KEY = 'mode';

/** The stored choice, or light. Storage that throws or holds anything else reads as light. */
export function readColorPreference(storage) {
  try {
    const stored = storage?.getItem(COLOR_PREFERENCE_KEY);
    return COLOR_PREFERENCES.includes(stored) ? stored : 'light';
  } catch {
    return 'light';
  }
}

export function writeColorPreference(storage, preference) {
  try {
    storage?.setItem(COLOR_PREFERENCE_KEY, preference);
  } catch {
    /* storage unavailable — the choice lasts until the tab closes */
  }
}

/** What the app renders: the choice, or the device's own when it follows the device. */
export function resolveColorMode(preference, deviceIsDark) {
  if (preference === 'system') return deviceIsDark ? 'dark' : 'light';
  return preference === 'dark' ? 'dark' : 'light';
}
